import './Navbar.scss';

import logo from './Logo_skinny.png';
import HomeIcon from '@mui/icons-material/Home';

import MenuIcon from '@mui/icons-material/Menu';

// import {NavLink} from 'react-router-dom';
import { Link } from 'react-scroll';
import { useState } from 'react';
import NavBurger from './NavBurger/NavBurger';


const Navbar = () => {

  const [navBlack, setNavBlack] = useState(false);

  const [showNav, setShowNav] = useState(false);
 

  const transitionNav = () => {
    window.scrollY > 100 ? setNavBlack(true) : setNavBlack(false);
  }

  const handleShowBurger= () => {
    console.log(showNav);
    setShowNav(!showNav);
  }

  useState(() => {
    document.addEventListener("scroll", transitionNav);
  })


 
  return (

    
    <>
    <div className= {`navbar ${navBlack ? "navbar--black" : "nav--transparent"}`}>

      <Link
       className='link_home'
       activeClass="active"
              to="banner"
              spy
              smooth
              offset={0}
              duration={500}
       
       >  
        <HomeIcon className='homeIcon'/> Accueil
   
      </Link>
      <Link
         className='link_presentation'
         activeClass="active"
              to="videoc"
              spy
              smooth
              offset={0}
              duration={500}
         
         >  
          Présentation
      </Link> 
      

      <Link
          activeClass="active"
              to="banner"
              spy
              smooth
              offset={0}
              duration={500}
         >  
        <img src={logo} alt='logo' className='nav_logo' />
         
      </Link> 


      <Link
         className='link_category'
         activeClass="active"
              to="navpictures"
              spy
              smooth
              offset={0}
              duration={500}
       
         >  
          Catégories
      </Link> 


   

      <Link
         className='link_contact'
         activeClass="active"
              to="footer"
              spy
              smooth
              offset={0}
              duration={500}
         >  
          Contact
      </Link> 

      {/* <SocialLogos /> */}
  
    </div>

    <div className={`nav_mobile ${navBlack ? "nav_mobile--black" : "nav--transparent"}`}>
    <Link
          activeClass="active"
              to="banner"
              spy
              smooth
              offset={0}
              duration={500}
         >  
        <img src={logo} alt='logo' className='nav_logo' />
         
      </Link> 
    <button 
    className='nav_mobile-btn'
    onClick={handleShowBurger}> <MenuIcon className='btn-elem'/> </button>
    </div>
    
    <NavBurger showNav={showNav} handleShowBurger={handleShowBurger} />
   
    </>
  )
}

export default Navbar;


